import React from 'react'
 import { Link } from 'react-router-dom'
const Home = () => {
    document.title="Queen Resturant"
  return (
    <>
      <div className="background">
      <div className="navs navsbar">
    <div className="logo"> <img className="img" src="https://img.freepik.com/free-photo/restaurant-interior_1127-3394.jpg?w=2000" alt=""/>
     <h1> Queen Restsurant</h1></div>
     <Link to="/" className="toggle-button">
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
    </Link>
    {/* <div class="navbar-links"><ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/menu">Menu</Link></li>
        <li><Link to="/about">About</Link></li>
    </ul></div> */}
    <div className="container1" id="home_section">
  <h1 className="text">The Home Of Good Food</h1>
 </div>

    </div>
    </div>
    </>
  )
}

export default Home
